module.exports = __webpack_public_path__ + "img/404.7be04d77.svg";